import "./Results.css"
import PencilLogoGold from "../assets/Pencil_gold.svg";
import PencilLogoSilver from "../assets/Pencil_silver.svg";
import PencilLogoBronze from "../assets/Pencil_bronze.svg";

const Results = ({ activeCompetition }) => {
    const getPlacementText = (placement, totalUsers) => {
        if (placement === 0) return "🎉 Champion! You claimed the golden pencil!";
        if (placement === 1) return "🥈 Excellent work! Silver medal winner!";
        if (placement === 2) return "🥉 Great job! You earned bronze!";
        if (placement <= 5) return "⭐ Top performer! Keep it up!";
        if (placement <= 10) return "💪 Strong finish in the top 10!";
        if (placement < totalUsers / 2) return "👍 Good effort! Above average performance!";
        return "📈 Keep practicing! There's always next time!";
    }

    const getPlacementColor = (placement) => {
        if (placement === 0) return 'var(--primary-gold)';
        if (placement === 1) return '#C0C0C0';
        if (placement === 2) return '#CD7F32';
        if (placement <= 5) return 'var(--secondary-blue)';
        return 'var(--gray-600)';
    }

    const getUserPlacementSuffix = (place) => {
        const lastDigit = place % 10;
        const lastTwoDigits = place % 100;
        
        if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return 'th';
        if (lastDigit === 1) return 'st';
        if (lastDigit === 2) return 'nd';
        if (lastDigit === 3) return 'rd';
        return 'th';
    }

    return (
        <div className="results-container">
            {/* Podium Section */}
            <div className="podium-section">
                <h2 className="podium-header">🏆 Competition Winners</h2>
                <p className="podium-subtitle">This competition has ended. Congratulations to our top performers!</p>
                
                <div className="podium-display">
                    {/* Second Place - Left */}
                    <div className="podium-place second-place">
                        <div className="podium-rank">2nd</div>
                        <div className="podium-content">
                            <img 
                                alt="Silver pencil for second place" 
                                className="podium-pencil" 
                                src={PencilLogoSilver}
                            />
                            <div className="podium-user">
                                <p className="podium-username">
                                    {activeCompetition.compInfo.results.topUsers.length >= 2 
                                        ? activeCompetition.compInfo.results.topUsers[1].username 
                                        : "—"}
                                </p>
                                {activeCompetition.compInfo.results.topUsers.length >= 2 && (
                                    <p className="podium-score">
                                        {activeCompetition.compInfo.results.topUsers[1].score} pts
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="podium-bar silver"></div>
                    </div>

                    {/* First Place - Center */}
                    <div className="podium-place first-place">
                        <div className="podium-rank">1st 👑</div>
                        <div className="podium-content">
                            <img 
                                alt="Gold pencil for first place" 
                                className="podium-pencil" 
                                src={PencilLogoGold}
                            />
                            <div className="podium-user">
                                <p className="podium-username">
                                    {activeCompetition.compInfo.results.topUsers.length >= 1 
                                        ? activeCompetition.compInfo.results.topUsers[0].username 
                                        : "—"}
                                </p>
                                {activeCompetition.compInfo.results.topUsers.length >= 1 && (
                                    <p className="podium-score">
                                        {activeCompetition.compInfo.results.topUsers[0].score} pts
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="podium-bar gold"></div>
                    </div>

                    {/* Third Place - Right */}
                    <div className="podium-place third-place">
                        <div className="podium-rank">3rd</div>
                        <div className="podium-content">
                            <img 
                                alt="Bronze pencil for third place" 
                                className="podium-pencil" 
                                src={PencilLogoBronze}
                            />
                            <div className="podium-user">
                                <p className="podium-username">
                                    {activeCompetition.compInfo.results.topUsers.length >= 3 
                                        ? activeCompetition.compInfo.results.topUsers[2].username 
                                        : "—"}
                                </p>
                                {activeCompetition.compInfo.results.topUsers.length >= 3 && (
                                    <p className="podium-score">
                                        {activeCompetition.compInfo.results.topUsers[2].score} pts
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="podium-bar bronze"></div>
                    </div>
                </div>
            </div>

            {/* User Results Section */}
            <div className="user-results-section">
                <h2 className="user-results-header">📊 Your Performance</h2>
                
                <div className="results-cards">
                    <div className="result-card placement-card" style={{ borderColor: getPlacementColor(activeCompetition.compInfo.results.usersPosition.place) }}>
                        <div className="card-icon" style={{ background: getPlacementColor(activeCompetition.compInfo.results.usersPosition.place) }}>
                            📍
                        </div>
                        <div className="card-content">
                            <p className="card-label">Your Placement</p>
                            <p className="card-value" style={{ color: getPlacementColor(activeCompetition.compInfo.results.usersPosition.place) }}>
                                {activeCompetition.compInfo.results.usersPosition.place + 1}
                                <sup>{getUserPlacementSuffix(activeCompetition.compInfo.results.usersPosition.place + 1)}</sup>
                            </p>
                            <p className="card-subtext">
                                out of {activeCompetition.compInfo.results.totalUsers} player{activeCompetition.compInfo.results.totalUsers !== 1 ? 's' : ''}
                            </p>
                        </div>
                    </div>

                    <div className="result-card score-card">
                        <div className="card-icon">
                            ⭐
                        </div>
                        <div className="card-content">
                            <p className="card-label">Final Score</p>
                            <p className="card-value score-value">
                                {activeCompetition.compInfo.results.usersPosition.score}
                            </p>
                            <p className="card-subtext">points earned</p>
                        </div>
                    </div>
                </div>

                <div className="result-message">
                    <p className="message-text">
                        {getPlacementText(activeCompetition.compInfo.results.usersPosition.place, activeCompetition.compInfo.results.totalUsers)}
                    </p>
                </div>
            </div>
        </div>
    );
}


export default Results;
